import {AppbarStateInterface} from "../interfaces";

export const AppbarConfig: AppbarStateInterface = {
  sidebarState: {
    collapse: true,
    title: "MyTRUMPF Cockpit",
    navItems: [
      {
        route: "/asset-management",
        label: "Asset Management"
      },
      {
        route: "/settings",
        label: "Settings"
      }
    ]
  },
  navItems: [
    {
      route: "/asset-management",
      label: "Asset Management",
      iconName: "machine",
      iconWeight: "normal",
      iconSize: "25",
      iconColor: "white"
    },
    {
      route: "/feature-toggles",
      label: "Feature Toggles",
      iconName: "toggle-switch",
      cssClass: "mtc-appbar-feature-toggles-item",
      iconWeight: "normal",
      iconSize: "25",
      iconColor: "white"
    },
    {
      route: "/settings",
      label: "Settings",
      iconName: "cog",
      cssClass: "mtc-appbar-settings-item",
      iconWeight: "normal",
      iconSize: "25",
      iconColor: "white"
    },
    {
      route: "/logout",
      label: "Logout",
      iconName: "square-arrow-out",
      cssClass: "mtc-appbar-logout-item",
      iconWeight: "normal",
      iconSize: "25",
      iconColor: "white"
    }
  ],
  activeRoute: "/asset-management"
};
